import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { CardBody, Form } from 'react-bootstrap';
import { UpdateAnalysis } from '../../../../store/HR/Raqeeb/raqeebSlice';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import RsponseData from './RsponseData';
import { Card } from '../../../../components/card/card';
import useGetRotationPlan from '../../../../hooks/HR/use-get-RotationPlan';
import useGetPersons from '../../../../hooks/HR/use-get-persons';
// import { Link } from 'react-router-dom';

const ValidationForm = (t) => {
  return Yup.object({
    dateFrom: Yup.date().required(() => t('Required')),
    dateTo: Yup.date()
      .required(() => t('Required'))
      .min(Yup.ref('dateFrom'), () => t('يجب ان يكون اكبر من تاريخ البدء')),
  });
};

const UpdateRaqeebData = () => {
  // const [mode, setMode] = useState('All'); //

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [seccess, setSeccess] = useState([]);
  const [faild, setFaild] = useState([]);
  const [IsshowResult, setIsshowResult] = useState(false);
  const { loading, RotationPlanOptions } = useGetRotationPlan();
  const { dataEmployees } = useGetPersons();

  const formik = useFormik({
    initialValues: {
      dateFrom: '',
      dateTo: '',
      rotationPlanId: null,
      personId: null,
    },
    validationSchema: ValidationForm(t),
    onSubmit: (values, { resetForm }) => {
      setFaild([]);
      setSeccess([]);
      dispatch(
        UpdateAnalysis({
          dateFrom: values.dateFrom,
          dateTo: values.dateTo,
          rotationPlanId: values.rotationPlanId,
          personId: values.personId,
          // rotationPlanId: mode === 'RotationPlan' ? values.rotationPlanId : null,
          // personId: mode === 'Emp' ? values.personId : null,
        })
      )
        .unwrap()
        .then((res) => {
          if (res?.succeeded) {
            if (res?.data?.faild?.length > 0) {
              setFaild(res?.data?.faild);
            }
            if (res?.data?.seccess?.length > 0) {
              setSeccess(res?.data?.seccess);
            }
            CustomAlert({
              action: 'Add',
              msg: t('DataUpdatedSuccessfully'),
              Timer: 10000,
            });
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
            formik.setSubmitting(false);
          }

          formik.setSubmitting(false);
          setIsshowResult(true);
        })
        .catch((error) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    },
  });

  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome',
    },
    {
      name: t('UpdateAttendanceData'),
      link: null,
    },
  ];

  return (
    <>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName="UpdateAttendanceData" />

      <Card>
        <CardBody className="p-4">
          <Form onSubmit={formik.handleSubmit}>
            <div className="row ">
              <div className="col-xl-4">
                <div className="row ">
                  <div className="col-xl-12">
                    <div className="input-group mb-3 ">
                      <span className="input-group-text">{t('From')}</span>
                      <Form.Control
                        className="form-control text-center"
                        type="date"
                        name="dateFrom"
                        onChange={formik.handleChange}
                        value={formik.values.dateFrom}
                        // isInvalid={!!formik.errors.dateFrom}
                      />
                    </div>
                  </div>

                  <div className="col-xl-12">
                    <div className="input-group mb-3">
                      <span className="input-group-text">{t('To')}</span>
                      <Form.Control
                        className="form-control text-center"
                        type="date"
                        name="dateTo"
                        onChange={formik.handleChange}
                        value={formik.values.dateTo}
                        // isInvalid={!!formik.errors.dateTo}
                      />
                    </div>
                  </div>

                  {/* <div className="form-group mb-3">
                      <label className="form-label">{t('From')}</label>
                      <Form.Control
                        className="form-control text-center"
                        type="date"
                        name="dateFrom"
                        onChange={formik.handleChange}
                        value={formik.values.dateFrom}
                        isInvalid={!!formik.errors.dateFrom}
                      />
                    </div> */}
                </div>
              </div>

              <div className="col-xl-8">
                <div className="row ">
                  <div className="col-xl-12">
                    <div className={`input-group flex-nowrap mb-3   `}>
                      <span className="input-group-text  fw-bold">{t('RotationPlan')}</span>
                      <Select
                        // isDisabled={mode === 'All' || mode === 'Emp'}
                        classNamePrefix="react-select"
                        className="w-100"
                        isLoading={loading}
                        isSearchable={true}
                        isClearable
                        options={RotationPlanOptions}
                        value={
                          formik.values.rotationPlanId === null
                            ? null
                            : RotationPlanOptions?.find(
                                (f) => f.value === formik.values.rotationPlanId
                              )
                        }
                        onChange={(option) => {
                          formik.setFieldValue(
                            'rotationPlanId',
                            option === null ? null : option.value
                          );
                        }}
                        placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      />
                    </div>
                  </div>

                  <div className="col-xl-12">
                    <div className={`input-group flex-nowrap mb-3  `}>
                      <span className="input-group-text  fw-bold">{t('Employee')}</span>
                      <Select
                        // isDisabled={mode === 'All' || mode === 'RotationPlan'}
                        classNamePrefix="react-select"
                        className="w-100"
                        isLoading={loading}
                        isSearchable={true}
                        isClearable
                        name="personId"
                        options={dataEmployees}
                        value={
                          formik.values.personId === null
                            ? null
                            : dataEmployees?.find((f) => f.value === formik.values.personId)
                        }
                        onChange={(option) => {
                          formik.setFieldValue('personId', option === null ? null : option.value);
                        }}
                        placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                        formatOptionLabel={(option) => (
                          <div className="d-flex justify-content-between   ">
                            <div className="">{option.label}</div>
                            <div className="text-theme fw-bold">{option.employeeNumber}</div>
                          </div>
                        )}
                        filterOption={(candidate, inputValue) => {
                          // البحث في الاسم أو رقم الموظف
                          const searchValue = inputValue.toLowerCase();
                          const labelMatches = candidate?.label
                            ?.toLowerCase()
                            ?.includes(searchValue);
                          const numberMatches = candidate?.data?.employeeNumber
                            ?.toLowerCase()
                            .includes(searchValue);
                          return labelMatches || numberMatches;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4">
                <div className="form-group mb-3 d-flex justify-content-end">
                  <button
                    // disabled={formik.isSubmitting}
                    disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
                    type="submit"
                    className="btn me-1 btn-theme   w-100">
                    {formik.isSubmitting ? (
                      <div className="spinner-border spinner-border-sm me-2"></div>
                    ) : (
                      <i className="bi bi-repeat fa-fw me-2"></i>
                    )}
                    {t('UpdateData')}
                  </button>
                </div>
              </div>
            </div>
          </Form>

          {IsshowResult && (
            <div className="row mt-3">
              <div className="col-lg-6 text-center mt-2">
                <div className="bg-inverse bg-opacity-10 rounded-4 p-2 ">
                  <div className="fw-bold">
                    {t('DataHasBeenUpdated')}
                    <span className="fs-3 text-theme"> {seccess?.length} </span>
                    {t('employee')}
                  </div>
                  {seccess?.length > 0 && <RsponseData data={seccess} />}
                </div>
              </div>
              <div className=" col-lg-6 text-center mt-2">
                <div className="bg-inverse bg-opacity-10 rounded-4 p-2">
                  <div className="fw-bold">
                    {t('FailedDataUpdate')}
                    <span className="fs-3 text-theme"> {faild?.length} </span>
                    {t('employee')}
                  </div>
                  {faild?.length > 0 && <RsponseData data={faild} />}
                </div>
              </div>
            </div>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default UpdateRaqeebData;
